import * as v from "valibot";

import { rpcContract } from "../rpc";

export const createUnifiedLinkRpcContract = rpcContract({
  name: "createUnifiedLink",
  paramsSchema: v.object({
    // Basic link fields
    title: v.pipe(v.string(), v.minLength(1), v.maxLength(50)),
    url: v.pipe(v.string(), v.url(), v.maxLength(2000)),
    teaser: v.optional(v.pipe(v.string(), v.maxLength(150))),
    fileId: v.optional(v.string()),

    // Discount-specific fields (optional, makes it a discount when provided)
    has_discount: v.optional(v.boolean(), false),
    brand_id: v.optional(v.nullable(v.string())),
    is_code_required: v.optional(v.boolean()),
    code: v.optional(v.string()),
    start_date: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    end_date: v.optional(v.pipe(v.string(), v.isoTimestamp())),
    published_at: v.optional(v.pipe(v.string(), v.isoTimestamp())),

    // Premium content fields
    contentTier: v.optional(v.picklist(["free", "premium"])),
    oneTimePriceCents: v.optional(v.pipe(v.number(), v.minValue(100), v.maxValue(99999))),

    // Community scoping
    communityId: v.optional(v.string()),
  }),
  resultSchema: v.object({
    linkId: v.string(),
  }),
});

export type CreateUnifiedLinkParams = v.InferOutput<(typeof createUnifiedLinkRpcContract)["paramsSchema"]>;
export type CreateUnifiedLinkResult = v.InferOutput<(typeof createUnifiedLinkRpcContract)["resultSchema"]>;
